const examActions = {
  GET_PROJECT_DETAILS: 'GET_PROJECT_DETAILS',
  SET_PROJECT_DETAILS: 'SET_PROJECT_DETAILS',
  GET_HEART_BEAT: 'GET_HEART_BEAT',
  SET_HEART_BEAT: 'SET_HEART_BEAT',
  GET_INSTRUCTIONS: 'GET_INSTRUCTIONS',
  SET_INSTRUCTIONS: 'SET_INSTRUCTIONS',
  GET_EXAM_QUESTIONS: 'GET_EXAM_QUESTIONS',
  SET_EXAM_QUESTIONS: 'SET_EXAM_QUESTIONS',
  SET_SUBMIT_ANSWER: 'SET_SUBMIT_ANSWER',
  GET_SUBMIT_ANSWER: 'GET_SUBMIT_ANSWER',
  AUDIT_LOG: 'AUDIT_LOG',
  END_EXAM: 'END_EXAM',
  ACTIVE_PING: 'ACTIVE_PING',
  GET_ACTION_RETRIEVE: 'GET_ACTION_RETRIEVE',
  GET_EXAM_EVENTS: 'GET_EXAM_EVENTS',///////Broadcast events////
  SET_EXAM_EVENTS: 'SET_EXAM_EVENTS',
  GET_EXAM_SCHEDULE:'GET_EXAM_SCHEDULE',
  SET_EXAM_SCHEDULE:'SET_EXAM_SCHEDULE', //// Candidate Profile /////
  GET_CANDIDATE_SCORE: 'GET_CANDIDATE_SCORE',
  SET_CANDIDATE_SCORE: 'SET_CANDIDATE_SCORE',
  SET_CANDIDATE_SCORE_LOADING: 'SET_CANDIDATE_SCORE_LOADING',
  SET_CANDIDATE_SCORE_ERROR: 'SET_CANDIDATE_SCORE_ERROR',
  CLEAR_CANDIDATE_SCORE: 'CLEAR_CANDIDATE_SCORE',
  INLINE_UPLOAD_FILE: 'INLINE_UPLOAD_FILE',
  INLINE_DELETE_FILE: 'INLINE_DELETE_FILE',
  SET_INLINE_UPLOAD_URL: 'SET_INLINE_UPLOAD_URL',
  SET_SAFE_EXAM_CONFIG: 'SET_SAFE_EXAM_CONFIG',
}

export default examActions;